import { useState } from 'react';

import * as tracking from './tracking';
import type { Environment } from 'client-site-chrome-ui/environment';
import { communicationPreferences } from 'client-site-chrome-ui/services/communicationPreferences';

const redirectUrl = '/emails/thanks-for-signing-up';

export const useCommunicationPreferences = (env: Environment) => {
  const [hasSignUpError, setHasSignUpError] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSignUp = async (email: string) => {
    setLoading(true);
    const result = await communicationPreferences(env, email);
    if (result) {
      setLoading(false);
      if (result instanceof Error) {
        await tracking.sendNewsletterSubmissionErrorEvent(result.message);
        setHasSignUpError(true);
      } else {
        tracking.sendNewsletterSubmissionSuccessEvent(email);
        window.location.assign(redirectUrl);
      }
    }
  };

  return { hasSignUpError, loading, onSignUp };
};
